<template>
  <div>
    <!-- <v-container fluid> -->
    <v-layout justify-center>
      <v-flex
        xs12
        sm12
        md10
        lg5
        xl5
      >
        <div class="payment-card">
          <div class="payment-card-title d-flex align-center">
            {{ $t('customer.payWithLabel') }}
            <div class="pl-2">
              <img
                src="../../../assets/images/fastpay.svg"
                style="width: 100px; height: 30px; object-fit: contain"
              >
            </div>
          </div>
          <div class="payment-card-body">
            <form @submit.prevent="submitForm()">
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    :label="$t('columns.amount')"
                    v-model="form.amount_usd"
                    :error-messages="errors.collect('Amount')"
                    v-validate="'required'"
                    data-vv-name="Amount"
                    prepend-icon="attach_money"
                    @input="calcAmount()"
                  />
                </v-flex>

                <v-flex
                  v-if="form.amount"
                  xs12
                >
                  <div style="font-size: 16px">
                    <span>{{ $t('customer.amountInIqdIs') }}</span>
                    <span class="rtl-pl-6">IQD{{ form.amount.toLocaleString() }}</span>
                  </div>
                </v-flex>

                <v-flex
                  xs12
                  class="py-4"
                >
                  <v-btn
                    style="height: auto"
                    color="primary"
                    depressed
                    :disabled="!form.amount || form.amount < 250"
                    type="submit"
                    :loading="loading"
                  >
                    {{ $t('customer.nextButton') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </form>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Axios from 'axios'
export default {
  data() {
    return {
      loading: false,
      exRate: 0,
      form: {
        amount_usd: null,
        amount: null,
        currency: 'IQD'
      }
    }
  },

  mounted() {
    this.getLastExRate()
  },

  methods: {
    calcAmount() {
      this.form.amount = Number(this.form.amount_usd) * Number(this.exRate)
      this.form.amount = parseInt(this.form.amount)
    },

    getLastExRate() {
      let token = localStorage.getItem('access_token')
      Axios.get('api/currency-rate/latest', { headers: { Authorization: 'Bearer ' + token } }).then(res => {
        this.exRate = res.data.ex_rate
      })
    },

    submitForm() {
      this.$validator.validateAll().then(() => {
        this.loading = true
        let token = localStorage.getItem('access_token')
        Axios.post('api/pay-with-fastpay', this.form, { headers: { Authorization: 'Bearer ' + token } }).then(res => {
          window.open(res.data.data.redirect_uri)
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>

<style>
.payment-card {
  border: 1px solid #ddd;
  margin-top: 16px;
  padding: 16px;
  border-radius: 8px;
}
.payment-card-title {
  font-size: 20px;
  font-weight: 500;
}
.payment-currency-btn .btn__content {
  width: 60px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/payWithFastPay.vue